// extracted by mini-css-extract-plugin
module.exports = {"container":"ReviewBoardApproved_container__3R5ep","imagesContainer":"ReviewBoardApproved_imagesContainer__1mJvx"};